import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ConfirmpasswordComponent } from './confirmpassword/confirmpassword.component';
import { DeveloperLoginComponent } from './developer-login/developer-login.component';
import { EmployerLoginComponent } from './employer-login/employer-login.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { LoginRegisterComponent } from './login-register.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';

const routes: Routes = [
  {
    path: '',
    component: LoginRegisterComponent
  },
  {
    path: 'employerLogin',
    component: EmployerLoginComponent
  },
  {
    path: 'developerLogin',
    component: DeveloperLoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotpasswordComponent
  },
  {
    path: 'change-password',
    component: ConfirmpasswordComponent
  }
];

@NgModule({
  declarations: [
    LoginRegisterComponent,
    EmployerLoginComponent,
    DeveloperLoginComponent,
    ForgotpasswordComponent,
    ConfirmpasswordComponent,
    LoginComponent,
    RegisterComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)],
  exports: [RouterModule]
})


export class LoginModule { }
